import { FC, useEffect, useState } from "react"


export interface ToggleButtonProps {
    onclick: () => void;
    title: string;
    subtitle: string | null;
    isToggledValue: boolean;
    isPremiumFeature?: boolean | null;
}

const ToggleButton: FC<ToggleButtonProps> = ({ onclick, title, isToggledValue, subtitle, isPremiumFeature = false }) => {

    const [isToggled, setIsToggled] = useState<boolean>(false);

    useEffect(() => {
        setIsToggled(isToggledValue);
    }, [])


    const handleToggale = () => {
        setIsToggled(!isToggled);
        onclick();
    };

    return (<>
        <div className="setting_check_group">
            <div className="setting_check_block">
                <label htmlFor="name" className="field_title setting">
                    {title}
                </label>
                <a href="#" onClick={onclick} className="setting_check w-inline-block">
                    {
                        isToggledValue ?
                            <img src="/assets/images/check_yes.svg" loading="lazy" alt="" />
                            :
                            <img src="/assets/images/check_no.svg" loading="lazy" alt="" />

                    }
                </a>
            </div>
            {
                subtitle ?
                    <div style={{ width: "70%" }}>
                        {subtitle}
                    </div>
                    : null
            }
            {
                isPremiumFeature &&
                <div className="subscribe_group">
                    <img
                        src="assets/images/ic_premium_menu.svg"
                        loading="lazy"
                        alt=""
                        className="prem_icon_txt set_list"
                    />
                    <div className="icon_red_txt">למנויי פרימיום</div>
                </div>

            }
        </div>
    </>)
}


export default ToggleButton